export function validatePhoneNumber(phoneNumber) {
  const phoneRegex = /^((\(?\+45\)?)?)(\s?\d{2}\s?\d{2}\s?\d{2}\s?\d{2})$/;
  return phoneRegex.test(phoneNumber);
}

export function validateTextString(name, { minLength = 2, maxLength = 50 }) {
  const nameRegex = new RegExp(`^[a-zA-ZæøåÆØÅ ]{${minLength},${maxLength}}$`);
  return nameRegex.test(name);
}

export function validateWhitespace(str) {
  const whiteSpaceRegex = /\S/;
  return whiteSpaceRegex.test(str);
}

export function removeExtraWhitespace(str) {
  // Replace multiple consecutive whitespace characters with a single space
  const normalizedText = str.replace(/\s+/g, " ");

  // Remove leading and trailing whitespace
  const trimmedText = normalizedText.trim();

  return trimmedText;
}

export function removeWhitespace(str) {
  // Remove whitespace characters
  const normalizedText = str.replace(/\s+/g, "");

  // Remove leading and trailing whitespace
  const trimmedText = normalizedText.trim();

  return trimmedText;
}
